const packageName = 'case-connector';
const version = '0.30.0'; // x-release-please-version

export const versionString = `${packageName}@${version}`;
